// Copyright (c) 2016 Deere & Company

import application from './application';
import busyCounter from '../../../shared/reducers/busy-counter';
import claim from './battery-claim';
import {combineReducers} from 'redux';
import confirmationModal from './confirmation-modal';
import createClaimModal from './create-claim-modal';
import customer from './customer';
import failureModes from './failure-modes';
import formValidation from './form-validation';
import installedBy from './installed-by';
import isActionButtonDisabled from './is-action-button-disabled';
import isCopied from './is-copied';
import isEditable from './is-editable';
import isStickyHeaderVisible from './is-sticky-header-visible';
import isValidClaim from './is-valid-claim';
import product from './product-details';
import temporaryObjectKey from './temporary-object-key';
import warrantyStatusModal from './warranty-status-modal';

export const getCombinedReducers = () => combineReducers({
    application,
    busyCounter,
    claim,
    confirmationModal,
    createClaimModal,
    customer,
    failureModes,
    formValidation,
    installedBy,
    isActionButtonDisabled,
    isCopied,
    isEditable,
    isStickyHeaderVisible,
    isValidClaim,
    product,
    temporaryObjectKey,
    warrantyStatusModal
});



// WEBPACK FOOTER //
// ./src/claim/battery/reducers/index.js